<template>
	<div class="merchant_content" v-if="mode === 'cs'">
		<div class="detail_title" @click="$router.go(-1)">
			<span class="icon LEFTARROW mr_8"></span>
			<h3 class="title_m">{{ $t('merchant.title5') }}</h3>
		</div>
		<div class="customer_detail">
			<div class="customer_detail_item">
				<p class="mr_4 title_m">{{ $t('banner2.text1') }}</p>
				<span class="WATCH icon"></span>
			</div>
			<span
				>10:00 - 19:00<br />
				{{ $t('banner2.text2') }}
			</span>
		</div>
		<div class="customer_detail">
			<div class="customer_detail_item">
				<p class="mr_4 title_m">{{ $t('banner2.text3') }}</p>
				<span class="ONLINE icon"></span>
			</div>
			<span
				>{{ $t('banner2.text4') }}<br />
				{{ $t('banner2.text5') }}
			</span>
		</div>
		<div class="customer_detail">
			<div class="customer_detail_item">
				<p class="mr_4 title_m">{{ $t('banner2.text6') }}</p>
				<span class="OFFLINE icon"></span>
			</div>
			<span
				>10:00 - 19:00<br />
				{{ $t('banner2.text7') }}
			</span>
		</div>
		<div class="button_area">
			<button class="button_bg_red mr_8" @click="mode = 'inquiry'">
				{{ $t('merchant.menu3') }}
			</button>
			<button class="button_bg_red" @click="mode = 'inquiryList'">
				{{ $t('merchant.menu4') }}
			</button>
		</div>
	</div>
	<div class="merchant_content" v-else-if="mode === 'inquiry'">
		<div class="detail_title" @click="back">
			<span class="icon LEFTARROW mr_8"></span>
			<h3 class="title_m">{{ $t('merchant.menu3') }}</h3>
		</div>
		<div class="q_write">
			<div class="select_wrap mb_10">
				<select class="contact_type" v-model="typeSeq">
					<option value="" selected disabled>
						{{ $t('cs.placeholder.type') }}
					</option>
					<option
						v-for="item in ticket_type_list"
						:key="item.seq"
						:value="item.seq"
					>
						{{ item.title }}
					</option>
				</select>
			</div>
			<input
				type="text"
				:placeholder="$t('cs.placeholder.title')"
				class="mb_10"
				v-model="title"
			/>
			<textarea
				class="ask"
				:placeholder="$t('cs.placeholder.content')"
				v-model="content"
			></textarea>
			<button
				class="merchant_button bg_red mt_50"
				:disabled="!fillForm"
				@click="registTicket"
			>
				{{ $t('button.register') }}
			</button>
		</div>
	</div>
	<div class="merchant_content" v-else-if="mode === 'inquiryList'">
		<div class="detail_title" @click="back">
			<span class="icon LEFTARROW mr_8"></span>
			<h3 class="title_m">{{ $t('merchant.menu4') }}</h3>
		</div>
		<accordion v-for="item in inquiryList" :key="item.seq">
			<accordion-item>
				<template v-slot:accordion-trigger>
					<div class="d_flex justify_between">
						<div class="d_flex align_items_center">
							<span class="list_num_m">{{ item._no }}</span>
							<span class="date mr_8">{{
								$dayjs(item.regdate).format('YYYY.MM.DD')
							}}</span>
							<span>{{ item.type_title }}</span>
						</div>
						<span v-if="item.status === 'PENDING'" class="pending">{{
							$t('cs.inquiry.pending')
						}}</span>
						<span v-else class="complete">{{ $t('cs.inquiry.complete') }}</span>
					</div>
					<p class="title_s mt_8">{{ item.title }}</p>
				</template>
				<template v-slot:accordion-content>
					<div class="notice-accordion-content">
						{{ item.content }}
					</div>
					<div v-if="item.reply">
						<span class="divide_line"></span>
						{{ item.reply }}
					</div>
				</template>
			</accordion-item>
		</accordion>

		<pagination
			:totalCount="pageNavigation.total_count"
			:totalPage="pageNavigation.total_page"
			:curPage="pageNavigation.cur_page"
			:point="pageNavigation.point"
			:firstPage="pageNavigation.first_page"
			:lastPage="pageNavigation.last_page"
			@change="pageChangeHandler"
		></pagination>
	</div>
	<div v-else-if="mode === 'detail'">
		<span class="icon LEFTARROW ma_16" @click="back"></span>
		<p class="title_m px_1 mb_16">{{ $t('merchant.menu4') }}</p>
	</div>
	<ModalMessageM
		v-if="messageModal"
		:show-close="false"
		@closeModal="messageModal = false"
	>
		<div class="status_icon success"></div>
		<p class="mb_40">
			{{ $t('cs.inquiry.text1') }} <br />
			{{ $t('cs.inquiry.text2') }}{{ $t('cs.inquiry.text3') }}
			<!--			{{ modalStatusMessage }}-->
		</p>
		<button class="merchant_button bg_red" @click="confirm">
			{{ $t('button.confirm') }}
		</button>
	</ModalMessageM>
</template>
<script>
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import pagination from '@/components/Pagination';
import { createTicket, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';
import { fetchTicketList } from '@/api/cs';
export default {
	name: 'SetupCs',
	components: {
		Accordion,
		AccordionItem,
		ModalMessageM,
		pagination,
	},
	data() {
		return {
			isShowList: true,
			mode: 'cs',
			parent_seq: 0,
			typeSeq: '',
			title: '',
			content: '',
			inquiryList: [],
			field_values: [],
			ticket_type_list: [],
			ticket_id: '',
			pageNavigation: {},
			curPage: 1,
			listCount: 12,
			messageModal: false,
		};
	},
	created() {
		this.init();
	},
	computed: {
		fillForm() {
			return !!this.typeSeq && !!this.title && !!this.content;
		},
	},
	methods: {
		back() {
			this.isShowList = true;
			this.mode = 'cs';
		},
		showDetail(transactionInfo) {
			this.transactionInfo = transactionInfo;
			this.isShowList = false;
		},
		init() {
			this.loadInquiryList();
			this.loadTicketTypeList();
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticket_type_list = data;
		},
		async registTicket() {
			const params = {
				parent_seq: this.parent_seq,
				type_seq: this.typeSeq,
				title: this.title,
				content: this.content,
				field_values: this.field_values,
			};
			await createTicket(params)
				.then(result => {
					this.ticket_id = result.ticket_id;
					this.isWrite = false;
				})
				.catch(commonError);
			this.mode = 'inquiryList';
			this.init();
		},
		async loadInquiryList() {
			const params = {
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchTicketList(params).catch(
				commonError,
			);
			this.inquiryList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadInquiryList();
		},
		toDetail(seq) {
			this.$router.push({
				name: 'merchant-console-cs-inquiry-detail',
				query: { ticket_seq: seq },
			});
		},
		confirm() {
			this.messageModal = false;
			this.mode = 'inquiryList';
		},
	},
};
</script>
<style></style>
